<template lang="pug">
v-row.px-6
    v-col(v-for="(c, index) in dealerData ? sortedCars : sortedCars.slice(0,9)" :key="c.ID" cols=12 lg=4 )
        CarTile(:car="c" :index="index" @updateSelected="updateSelected" :dealerData="dealerData" :selectedIndex="selectedIndex" )
</template>
<script>
import CarTile from "./CarTile.vue";
export default {
  props: ["sortedCars", "dealerData","selectedIndex"],
  components: { CarTile },
  data() {
    return {};
  },
  methods: {
    updateSelected(index) {
      if (this.dealerData) {
        this.$emit("selectedCar", index);
      }
      this.$emit("updateSelected", index);
    },
  },
};
</script>
